import React, { ReactElement } from 'react';
import { format, parseISO } from 'date-fns';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import { de } from 'date-fns/locale';
import styles from './pickup-info.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';

export interface PickupInfoComponentProps {
  readonly time: string;
  readonly showIcon?: boolean;
  readonly bold?: boolean;
}

function PickupInfoComponent({
  time,
  showIcon = true,
  bold = true
}: PickupInfoComponentProps): ReactElement {
  const { formatMessage }: NamespacedIntl = useNamespacedIntl('storefinder');
  const textClasses = classNames({ bold: bold });

  function formatDate(dateString: string): string {
    const date = parseISO(dateString);
    return format(date, "dd.MM.yyyy 'ab' HH:mm", { locale: de });
  }

  return (
    <span className={styles['pickup-info']}>
      {showIcon && (
        <ImageComponent
          src={'/assets/icons/ellipse.svg'}
          alt={`pickup icon`}
          width={12}
          height={12}
        />
      )}
      <span className={textClasses}>
        {formatMessage('pickupTime', { pickupTime: formatDate(time) })}
      </span>
    </span>
  );
}

export default PickupInfoComponent;
